import axios from "axios"
import {tansParams} from '../utils/ruoyi';
import JSONBig from 'json-bigint'

var instance = axios.create({
    baseURL:process.env.VUE_APP_BASE_API,
    timeout: 5000,
    headers: { "Accept": "application/x-www-form-urlencoded,application/json;charset=UTF-8"},
    responseType: 'json',
    withCredentials: true,
    transformResponse: [function (data) {
        try {
          // 如果转换成功则返回转换的数据结果
          return JSONBig.parse(data)
        } catch (err) {
          // 如果转换失败，则包装为统一数据格式并返回
          return {
            data
          }
        }}
    ]

});

instance.interceptors.request.use(function(config) {
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
        config._v=Date.now()

      }else{
        config = {
            ...config,
            _v: Date.now()
        }
      }

    return config
}, function(error) {
    return Promise.reject(error);
})

// Add a response interceptor
instance.interceptors.response.use(function(response) {

    if (response && response.data) {
        if (response.data.code == 200) {
            return response.data
        }
    }
    let error = new Error()
    error.code = response.data.code
    error.message = response.data.msg
    error.requrl = response.config.url
    throw error
}, function(error) {

    if (error.response && error.response.data) {
        // let code = error.response.data.code;
        //暂关接口登录拦截
        return
    }

    let err = new Error()
        // handle timeout
    if (error.config.method == 'get' && error.message.indexOf('timeout') == 0) {
        let retry = error.config['retry'] || 1
        if (retry >= 3) {
            err.code = 400
            err.message = '网络异常，请稍后再试!'
        } else {
            // 解决base url的问题
            // error.config.url = error.config.url.replace(/\/api/g, '')
            error.config['retry'] = retry + 1
            return instance.request(error.config)
        }
    } else {

        // handle other error
        err.code = 500
        err.message = '服务器异常，请稍后再试!'
        if (error && error.response) {
            if (error.response.data) {
                let data = error.response.data
                err.code = data.code || 500
                err.message = data.message || '服务器异常，请稍后再试!'
            } else if (error.response.status !== 500) {
                err.code = 400
                err.message = '网络异常，请稍后再试!'
            }
        }
    }
    return Promise.reject(err)
})

// ----  接口定义开始-----
let defines = {

    getlist: (data) => {
        let url = "/sfxlow/news/list"+data
        return instance.get(url)
    },

    getli: (data) => {
      let url = "/sfxlow/news/"+data
      return instance.get(url)
  },
    addmessage: (data) => {
        let url = "/sfxlow/message/board"
        return instance.post(url,data)
    },
    getbannerlist:()=>{
      let url = "/sfxlow/banner/list"
      return instance.get(url)

    }
}

let apis = {}
Object.keys(defines).forEach((name) => {
    apis[name] = function(params) {
        var req = defines[name](params)
        return req;
    };
});
export default apis














